module.exports = __webpack_public_path__ + "media/images/gallery/search_off-4b5e988f540a610eb7df656503a1d7d5.gif";